var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    [_vm.$s.btn]:true,
    [_vm.$s[_vm.color]]:_vm.color,
    [_vm.$s.large]:_vm.large,
    [_vm.$s.disabled]: _vm.disabled,
  },attrs:{"type":_vm.type,"disabled":_vm.disabled}},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin",class:_vm.$s.loadingIcon}):[_vm._t("default"),(_vm.iconName)?_c('i',{class:{
        [_vm.iconName]:true,
        [_vm.$s.iconWithText]:_vm.$slots.default
      }}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }